import { render, staticRenderFns } from "./AuditStep1A.vue?vue&type=template&id=bfae7cda&scoped=true"
import script from "./AuditStep1A.vue?vue&type=script&lang=js"
export * from "./AuditStep1A.vue?vue&type=script&lang=js"
import style0 from "./AuditStep1A.vue?vue&type=style&index=0&id=bfae7cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfae7cda",
  null
  
)

export default component.exports